import { Enums } from '@cyborg-monorepo/hunter/common'

// HUN-1321: only companies with a Verity relationship (verityCustomerCode is
// set org-wide) and active status ever see the deprecation nudge. There's no
// per-user Verity provisioning signal, so the banner covers both "already
// set up" and "not provisioned yet" users via its own CTA + support link.
//
// HUN-1337: the banner announces a move that happens at VERITY_REDIRECT_CUTOFF
// (served on the profile as `verityRedirectCutoff`). Once that moment passes,
// the backend is gating login/refresh and anyone still in Hunter (SSO, exempt
// or pre-cutoff sessions) is past the move, so the "starting December 1"
// nudge is stale — hide it. Mirrors VerityRedirectService.isPastCutoff.
export function isPastVerityCutoff(
  verityRedirectCutoff: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!verityRedirectCutoff) return false

  const cutoff = new Date(verityRedirectCutoff)
  if (Number.isNaN(cutoff.getTime())) return false

  return now >= cutoff
}

export function shouldShowVerityBanner(
  isIframe: boolean,
  verityCustomerCode: string | null | undefined,
  companyStatus: Enums.CompanyStatus | undefined,
  verityRedirectCutoff?: string | null,
  now: Date = new Date(),
): boolean {
  if (isIframe) return false
  if (companyStatus !== Enums.CompanyStatus.ACTIVE) return false
  if (isPastVerityCutoff(verityRedirectCutoff, now)) return false

  return Boolean(verityCustomerCode)
}
